// GENERATED from shared/calc.js — DO NOT EDIT HERE.
// Regenerate: `npm run sync-theme` in workers/checkout/ (drift breaks the worker test suite).
(function () {
// BRANDS & GIFTS — gemeinsamer Kalkulations-Kern (single source of truth).
//
// Consumed by BOTH sides of the price logic:
//   workers/checkout/src/recompute.js      — authoritative server-side recompute
//   theme/assets/bg-calc.js      — GENERATED browser copy for the v12 calculator
//                                  (regenerate: `npm run sync-theme` in worker/;
//                                  a worker test fails on drift)
//
// Pure functions only — no I/O, no DOM, no rounding policy beyond v11's round2.
// Semantics are v11-verbatim (templates/product.json history); notably getVp()
// is order-dependent BY DESIGN: do not sort, do not pick max ab_menge.
//
// Metafield shapes (kalkulation.*):
//   staffelpreise flat:     [{ menge, artikelpreis }, ...]
//   staffelpreise per-size: [{ groesse, staffel: [{ menge, artikelpreis }, ...] }, ...]
//   veredelungen:           [{ id, bezeichnung, preis_pro_stueck?, vorkosten?,
//                              staffel?: [{ ab_menge, preis_pro_stueck }, ...] }, ...]

// Shape detection identical to v11: first entry carries `groesse` ⇒ per-size.
function isPerSize(staffelpreise) {
  return (
    Array.isArray(staffelpreise) &&
    staffelpreise.length > 0 &&
    typeof staffelpreise[0] === 'object' &&
    staffelpreise[0] !== null &&
    staffelpreise[0].groesse !== undefined
  );
}

// The applicable tier list: the per-size entry's staffel, or the flat array.
// Raw string comparison for groesse — v11 uses the raw <option> value.
// Returns null when the groesse doesn't match any entry.
function tiersFor(staffelpreise, groesse) {
  if (!isPerSize(staffelpreise)) return staffelpreise;
  for (var i = 0; i < staffelpreise.length; i++) {
    if (String(staffelpreise[i].groesse) === String(groesse)) return staffelpreise[i].staffel;
  }
  return null;
}

// Exact tier match — v11 only ever offers exact mengen in its <select>.
function findTier(tiers, menge) {
  if (!Array.isArray(tiers)) return null;
  for (var i = 0; i < tiers.length; i++) {
    if (Number(tiers[i].menge) === Number(menge)) return tiers[i];
  }
  return null;
}

// v11 getVp() — verbatim semantics: last matching entry IN ARRAY ORDER wins;
// menge below all ab_menge → FIRST entry's price, not 0.
function getVp(veredelung, menge) {
  var arr = veredelung.staffel;
  if (!Array.isArray(arr) || arr.length === 0) {
    return veredelung.preis_pro_stueck || 0;
  }
  var p = arr[0].preis_pro_stueck;
  for (var i = 0; i < arr.length; i++) {
    if (menge >= arr[i].ab_menge) p = arr[i].preis_pro_stueck;
  }
  return p;
}

// v11 compares the <option> value (string) against v.id (stringified).
function findVeredelung(veredelungen, id) {
  if (!Array.isArray(veredelungen)) return null;
  for (var i = 0; i < veredelungen.length; i++) {
    if (String(veredelungen[i].id) === String(id)) return veredelungen[i];
  }
  return null;
}

// v11's rounding — the only rounding this core knows.
function round2(x) {
  return Math.round(x * 100) / 100;
}

// v11's berechne() formula, verbatim:
//   apT = round2(ap·m), vpT = round2(vp·m), ges = round2(apT + vpT + vk),
//   stk = round2(ges / m)
function computeTotals(ap, vp, vk, menge) {
  var apT = round2(ap * menge);
  var vpT = round2(vp * menge);
  var ges = round2(apT + vpT + Number(vk));
  var stk = round2(ges / menge);
  return { apT: apT, vpT: vpT, ges: ges, stk: stk };
}

  window.BGCalc = { isPerSize: isPerSize, tiersFor: tiersFor, findTier: findTier, getVp: getVp, findVeredelung: findVeredelung, round2: round2, computeTotals: computeTotals };
})();
